// extracted by mini-css-extract-plugin
export var actions = "livre-module--actions--PsPNP";
export var addressBlock = "livre-module--addressBlock--wiZEF";
export var availability = "livre-module--availability--f2U0s";
export var cardEyebrow = "livre-module--cardEyebrow--vRzM0";
export var description = "livre-module--description--2gX78";
export var eyebrow = "livre-module--eyebrow--p0TvK";
export var featureCard = "livre-module--featureCard--LlSts";
export var featureGrid = "livre-module--featureGrid--nvyt7";
export var finalActions = "livre-module--finalActions--Q+CYg";
export var finalCallout = "livre-module--finalCallout--BjNbf";
export var finalEyebrow = "livre-module--finalEyebrow--UH0OZ";
export var hero = "livre-module--hero--APtxE";
export var heroContent = "livre-module--heroContent--uRUyS";
export var heroVisual = "livre-module--heroVisual--4A0hl";
export var lightbox = "livre-module--lightbox--Ykyre";
export var lightboxClose = "livre-module--lightboxClose--4MimS";
export var lightboxInner = "livre-module--lightboxInner--T+k7e";
export var lightboxMeta = "livre-module--lightboxMeta--ghG-C";
export var lightboxNav = "livre-module--lightboxNav--9O-rl";
export var lightboxNext = "livre-module--lightboxNext--H3a24";
export var lightboxPaper = "livre-module--lightboxPaper--LbR2v";
export var lightboxPrev = "livre-module--lightboxPrev--YYOB-";
export var locationCard = "livre-module--locationCard--gEION";
export var locationDetail = "livre-module--locationDetail--kHG9O";
export var locationGrid = "livre-module--locationGrid--6yMgV";
export var page = "livre-module--page--JrGfs";
export var previewCard = "livre-module--previewCard--7PuMd";
export var previewFrame = "livre-module--previewFrame--44qls";
export var previewGrid = "livre-module--previewGrid--SohFU";
export var previewMeta = "livre-module--previewMeta--bVn3i";
export var previewSection = "livre-module--previewSection--eXA-o";
export var priceLine = "livre-module--priceLine--eh-A5";
export var primaryButton = "livre-module--primaryButton--4Xi+s";
export var primaryButtonLight = "livre-module--primaryButtonLight--VOfIB";
export var proofItem = "livre-module--proofItem--x04qu";
export var proofStrip = "livre-module--proofStrip--9RQhO";
export var quickList = "livre-module--quickList--ogV0V";
export var readerList = "livre-module--readerList--I+Q6g";
export var readersCard = "livre-module--readersCard--1-JDW";
export var secondaryButton = "livre-module--secondaryButton--5tmz+";
export var secondaryButtonLight = "livre-module--secondaryButtonLight--Jz26x";
export var section = "livre-module--section--YP22e";
export var sectionHeader = "livre-module--sectionHeader--aYmB1";
export var specialCard = "livre-module--specialCard--atMVA";
export var specialContact = "livre-module--specialContact--zuabD";
export var specialGrid = "livre-module--specialGrid--NikWp";
export var specialIntro = "livre-module--specialIntro--P2s8W";
export var specialList = "livre-module--specialList--vsJm-";
export var specialSection = "livre-module--specialSection--ZwO02";
export var splitGrid = "livre-module--splitGrid--xtsRM";
export var storyCard = "livre-module--storyCard--kE6ss";
export var subtitle = "livre-module--subtitle--7zc1x";
export var visualCard = "livre-module--visualCard--YQZ3k";
export var visualMeta = "livre-module--visualMeta--PmzGK";